module.exports = __webpack_public_path__ + "img/corra-logo-dark.80498983.svg";